module.exports = __webpack_public_path__ + "static/media/rename.f8932d92.svg";